import React, { Component } from "react";
import { Field } from "./FieldComponent";
import { STATUS } from "../constant";
import { InnerLoader } from "./Loader";
import { isValidArray, clearDebounce } from "../helper";
import { isFunction, debounce } from "lodash";

export class SearchComponent extends Component {
  state = {};
  debounceSearch = null;

  componentDidMount() {
    const { sortData, getFilteredData } = this.props;
    isFunction(getFilteredData) && getFilteredData({ sortData });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { value } = nextProps;
    const { value: stateValue } = this.state;
    if (stateValue !== value) {
      this.setState({
        value: value || ""
      });
    }
  }

  onChange = (value, key) => {
    const {
      replacePattern,
      sortData,
      onChange,
      // onError,
      getFilteredData,
      delay = 1000
    } = this.props;
    const replaceText = replacePattern
      ? value.replace(replacePattern, "")
      : value.replace(/[\\]/, "");
    this.setState(
      {
        sorting: STATUS.LOADING,
        value: replaceText,
        isSearching: !!replaceText
      },
      () => {
        const { value } = this.state;
        clearDebounce(this.debounceSearch);
        this.debounceSearch = debounce(() => {
          const regex = new RegExp(replaceText, "ig");
          const filterData =
            (replaceText.trim() &&
              isValidArray(sortData) &&
              sortData.filter(data => {
                const keys = Object.keys(data);
                return keys.find(key => {
                  return regex.test(data[key]);
                });
              })) ||
            sortData;
          isFunction(onChange) && onChange({ searchedText: value.trim() }, key);
          isFunction(getFilteredData) &&
            getFilteredData({
              sortData: filterData,
              isSearching: !!value,
              value: replaceText
            });
          this.setState({ sorting: STATUS.SUCCESS });
        }, delay);
        this.debounceSearch();
      }
    );
  };
  onBlur = value => {};
  render() {
    const { isLoading, delay, disabled } = this.props;
    const { sorting, value } = this.state;
    return (
      <React.Fragment>
        <div
          style={{ display: "content", position: "relative" }}
          className="search-box form-group"
        >
          <InnerLoader
            loading={sorting === STATUS.LOADING || isLoading === STATUS.LOADING}
            style={{
              position: "absolute",
              right: "19px",
              zIndex: "100",
              top: "3px"
            }}
          />
          <Field
            placeholder="Search"
            {...this.props}
            onChange={this.onChange}
            value={value}
            delay={delay || 1000}
            disabled={disabled}
            onBlur={this.onBlur}
          />
        </div>
      </React.Fragment>
    );
  }
}
